import { useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { useGetActiveLandingPage } from "../../../../shared/hooks/useGetMasterData";
import "./Swipper.css";

function HomeCarousel() {
    const theme = useTheme();
    const mediaDownMD = useMediaQuery(theme.breakpoints.down("sm"));
    const [landingPage] = useGetActiveLandingPage()


    const listItem = landingPage.map((item) => {
        return {
            original: item.link_media,
            thumbnail: item.link_media,
            originalWidth: "100%",
        }
    })

    // const listItem = [
    //     {
    //         original: "https://firebasestorage.googleapis.com/v0/b/mostrans-storage.appspot.com/o/Admin-Career%2FPoster%20Waspada%20Website-01%20(3).jpg?alt=media&token=e1156469-7b47-4391-a44d-6aa74020f100",
    //         thumbnail: "https://firebasestorage.googleapis.com/v0/b/mostrans-storage.appspot.com/o/Admin-Career%2FPoster%20Waspada%20Website-01%20(2).jpg?alt=media&token=70f9df72-139c-49e1-8e16-de8bc632575f",
    //         originalWidth: "100%",
    //     },
    // ];


    return (
        <>
            <Swiper
                className="swiper-slide"
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{
                    clickable: true,
                    el: ".out-swiper-pagination",
                    renderBullet: (index, className) => {
                        return `<span class=${className}></span>`;
                    },
                }}
                loop={true}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                style={{
                    height: `${mediaDownMD ? "auto" : "400px"}`,
                    "--swiper-navigation-color": "#0A8C4A",
                    "--swiper-navigation-size": "30px",
                }}>
                {listItem.map((item, index) => (
                    <SwiperSlide key={index}>
                        <img src={item.original} alt="" width="100%" />
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="out-swiper-pagination"></div>
        </>
    );
}

export default HomeCarousel;
